/*eslint-disable*/

/*
This file is auto-generated by svg-list
https://github.com/psoaresbj/svg-list
*/

const ui = {
  ab: {
    viewbox: '0 0 32 32',
    paths: [
      'M32 21.8c.2 3-1.8 5.6-4.7 6.3l-7-21.4c-.4-1.4-1.4-2.5-2.8-2.9h5.8c5 0 7.8 2.1 7.8 6.6 0 1.7-.6 3.3-1.7 4.6l-.7.9.8.8c1.6 1.3 2.4 3.1 2.5 5.1zM10.7 6.9l5.8 17.8 1.2 3.8H25L17.9 6.6c-.6-1.9-1.9-3.2-4.8-3.2-1.4-.1-2.7.4-3.8 1.2.6.7 1.1 1.4 1.4 2.3zm-2.4 0l-.6-1.2c-.2.3-.3.6-.4 1L0 28.5h7.4l1.1-3.8H14L8.3 6.9z',
    ],
  },
  arrowDown: {
    viewbox: '0 0 32 32',
    paths: [
      'M16 10c.6 0 1 .4 1 1v7.7l3.3-3.3c.4-.4 1-.4 1.4 0 .2.2.3.5.3.7 0 .3-.1.5-.3.7l-4.9 4.9c-.2.2-.4.3-.7.3h-.2c-.3 0-.5-.1-.7-.3l-4.9-5c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l3.3 3.3V11c0-.6.4-1 1-1z',
    ],
  },
  arrowLeft: {
    viewbox: '0 0 32 32',
    paths: [
      'M22 16c0 .6-.4 1-1 1h-7.7l3.3 3.3c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.3 0-.5-.1-.7-.3l-4.9-4.9c-.2-.2-.3-.4-.3-.7v-.2c0-.3.1-.5.3-.7l5-4.9c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L13.3 15H21c.6 0 1 .4 1 1z',
    ],
  },
  arrowRight: {
    viewbox: '0 0 32 32',
    paths: [
      'M10 16c0-.6.4-1 1-1h7.7l-3.3-3.3c-.4-.4-.4-1 0-1.4.2-.2.5-.3.7-.3.3 0 .5.1.7.3l4.9 4.9c.2.2.3.4.3.7v.2c0 .3-.1.5-.3.7l-5 4.9c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l3.3-3.3H11c-.6 0-1-.4-1-1z',
    ],
  },
  arrowUp: {
    viewbox: '0 0 32 32',
    paths: [
      'M16 22c-.6 0-1-.4-1-1v-7.7l-3.3 3.3c-.4.4-1 .4-1.4 0-.2-.2-.3-.5-.3-.7 0-.3.1-.5.3-.7l4.9-4.9c.2-.2.4-.3.7-.3h.2c.3 0 .5.1.7.3l4.9 5c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L17 13.3V21c0 .6-.4 1-1 1z',
    ],
  },
  envelope: {
    viewbox: '0 0 32 32',
    paths: [
      'M.8 8.3c.2-.1.4-.1.7-.1h29.1c.2 0 .4.1.7.1h-.1L16 21.7.8 8.3zM0 10.9l14.5 13.2c.9.5 2 .5 2.9 0L32 10.8v19.8c0 .8-.7 1.5-1.5 1.5h-29C.7 32 0 31.3 0 30.5V10.9z',
    ],
  },
  facebook: {
    viewbox: '0 0 512 512',
    paths: [
      'M288 176v-64c0-17.664 14.336-32 32-32h32V0h-64c-53.024 0-96 42.976-96 96v80h-64v80h64v256h96V256h64l32-80h-96z',
    ],
  },
  instagram: {
    viewbox: '0 0 512 512',
    paths: [
      'M352 0H160C71.648 0 0 71.648 0 160v192c0 88.352 71.648 160 160 160h192c88.352 0 160-71.648 160-160V160C512 71.648 440.352 0 352 0zm112 352c0 61.76-50.24 112-112 112H160c-61.76 0-112-50.24-112-112V160C48 98.24 98.24 48 160 48h192c61.76 0 112 50.24 112 112v192z',
      'M256 128c-70.688 0-128 57.312-128 128s57.312 128 128 128 128-57.312 128-128-57.312-128-128-128zm0 208c-44.096 0-80-35.904-80-80 0-44.128 35.904-80 80-80s80 35.872 80 80c0 44.096-35.904 80-80 80z',
    ],
  },
  linkedin: {
    viewbox: '0 0 512 512',
    paths: [
      'M0 160h114.5v352H0V160zm426.4 4.1l-3.6-1.2c-1.5-.4-3.1-.6-4.6-.9-6.1-1.2-12.7-2.1-20.5-2.1-66.8 0-109.1 48.5-123 67.3V160H160v352h114.5V320s86.5-120.5 123-32v224H512V274.5c0-53.2-36.4-97.5-85.6-110.4zM56 0c30.9 0 56 25.1 56 56s-25.1 56-56 56S0 86.9 0 56 25.1 0 56 0z',
    ],
  },
  twitter: {
    viewbox: '0 0 512 512',
    paths: [
      'M512 97.248c-19.04 8.352-39.328 13.888-60.48 16.576 21.76-12.992 38.368-33.408 46.176-58.016-20.288 12.096-42.688 20.64-66.56 25.408C411.872 60.704 384.416 48 354.464 48c-58.112 0-104.896 47.168-104.896 104.992 0 8.32.704 16.32 2.432 23.936-87.264-4.256-164.48-46.08-216.352-109.792-9.056 15.712-14.368 33.696-14.368 53.056 0 36.352 18.72 68.576 46.624 87.232-16.864-.32-33.408-5.216-47.424-12.928v1.152c0 51.008 36.384 93.376 84.096 103.136-8.544 2.336-17.856 3.456-27.52 3.456-6.72 0-13.504-.384-19.872-1.792 13.6 41.568 52.192 72.128 98.08 73.12-35.712 27.936-81.056 44.768-130.144 44.768-8.608 0-16.864-.384-25.12-1.44C46.496 446.88 101.6 464 161.024 464c193.152 0 298.752-160 298.752-298.688 0-4.64-.16-9.12-.384-13.568 20.832-14.784 38.336-33.248 52.608-54.496z',
    ],
  },
  youtube: {
    viewbox: '0 0 512 512',
    paths: [
      'M490.24 113.92c-13.888-24.704-28.96-29.248-59.648-30.976C399.936 80.864 322.848 80 256.064 80c-66.912 0-144.032.864-174.656 2.912-30.624 1.76-45.728 6.272-59.744 31.008C7.36 138.592 0 181.088 0 255.904v.256c0 74.496 7.36 117.312 21.664 141.728 14.016 24.704 29.088 29.184 59.712 31.264C112.032 430.944 189.152 432 256.064 432c66.784 0 143.872-1.056 174.56-2.816 30.688-2.08 45.76-6.56 59.648-31.264C504.704 373.504 512 330.688 512 256.192v-.16-.096c0-74.848-7.296-117.344-21.76-142.016zM192 352V160l160 96-160 96z',
    ],
  },
};
export default ui;
